
















































































































































































































import {Component, Prop, PropSync} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {LadingStore} from "@/modules/ladings/store";
import {LadingPaymentType} from "@/enums/type";
import ComplaintCustomerForm from "@/modules/complaintcustomer/Form/index.vue";
import PrintLading from "@/modules/ladings/Print/index.vue";
import {LadingCustomerStatus} from "@/enums/status/ladingcustomerstatus";

@Component({
    name: "DetailLading",
    components: {PrintLading, ComplaintCustomerForm}
})
export default class extends mixins(CommonMixin) {
    @PropSync("visible", {type: Boolean, default: false}) syncVisible!: boolean;
    @Prop() id!: string;

    tabPane = '1';
    LadingPaymentType = LadingPaymentType;
    LadingCustomerStatus = LadingCustomerStatus;

    get lading() {
        return LadingStore.data[this.id];
    }

    printLading() {
        (this.$refs.printLadingInDetail as any).showChoosePrintLading();
    }

    async onConfirm() {
        try {
            await LadingStore.deleteLading(this.id);
            this.$message.success("Xóa vận đơn thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xóa vận đơn thất bại");
        }
    }
}
